import { Table, Button, Input, Popover, DatePicker, message } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import ScanIcon from "../../../assets/images/scanIcon.svg";
import FilterIcon from "../../../assets/images/filterNewICon.svg";
import NotesAdd from "../../../assets/images/note-add.svg";
import RenderInput from "../../../lib/components/RenderInput";
import CartTotalsPanel from "./CartTotalsPanel";

const CartSection = ({
  posConfig,
  options,
  productMap,
  pickProduct,
  productSearchInput,
  setProductSearchInput,
  setOptions,
  keyboard,
  filterDrawer,
  searchInputRef,
  clearProductSearchResults,
  onChangeInput,
  setOpen,
  setInputName,
  setIsInputFocused,
  onBarcodeInput,
  productSearchInputRef,
  setIsProductsFilter,
  setFilterDrawer,
  cart,
  themeJSON,
  estimateNo,
  setNotesPopup,
  setNotesValue,
  cartItems,
  hasExpandableRows,
  selectedProductInCart,
  cartColumns,
  qtyInputRef,
  setShowInputFields,
  setRealPrice,
  setFirstInputValue,
  setSelectedCustomMix,
  setCustomMixItems,
  setGroupName,
  setGroupQty,
  setExistingGroupItems,
  setOverPayedAmount,
  setAmount,
  pricePrecision,
  selectProductInCart,
  setQtyNumberFlag,
  setShowPaymentMethods,
  setSelectedProductInCart,
  setStockList,
  handleUpsertEstimate,
  deleteCart,
  openDisplayParkedBillModal,
  setEstimateNo,
  currenciesList,
  isAdvanceOrderEnabled,
  calendarVisible,
  setCalendarVisible,
  selectedDate,
  handleDateSelect,
}) => {
  return (
    <div style={{ width: "63.9%" }}>
      <div
        style={{
          display: "flex",
          width: "100%",
          padding: "0 0 0 1.7%",
        }}
      >
        <div style={{ width: "93%" }}>
          <RenderInput
            posConfig={posConfig}
            options={options}
            productMap={productMap}
            pickProduct={pickProduct}
            productSearchInput={productSearchInput}
            setProductSearchInput={setProductSearchInput}
            setOptions={setOptions}
            keyboard={keyboard}
            filterDrawer={filterDrawer}
            searchInputRef={searchInputRef}
            clearProductSearchResults={clearProductSearchResults}
            onChangeInput={onChangeInput}
            setOpen={setOpen}
            setInputName={setInputName}
            setIsInputFocused={setIsInputFocused}
            onBarcodeInput={onBarcodeInput}
            productSearchInputRef={productSearchInputRef}
          />
        </div>
        <Button
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            // width: "4.5%",
            margin: "0 0.2vw 0 0.8vw",
            borderRadius: "7px",
            height: "inherit",
            borderColor: "#fff",
          }}
          onClick={() => setIsProductsFilter(true)}
        >
          <img src={ScanIcon} style={{ height: "2.7vh" }} />
        </Button>
        <Button
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            // width: "4.5%",
            margin: "0 1vw 0 0.5vw",
            borderRadius: "7px",
            height: "inherit",
            borderColor: "#fff",
          }}
          id="sm-product-drawer"
          onClick={() => {
            setFilterDrawer(true);
          }}
        >
          <img src={FilterIcon} style={{ height: "2.7vh" }} />
        </Button>
      </div>

      <div style={{ padding: "1.5%" }}>
        {cart.layAway === "Y" && posConfig?.advanceLayaway === "Y" ? (
          <div
            style={{
              position: "absolute",
              bottom: "29vh",
              left: "56vw",
            }}
          >
            <span style={{ opacity: "0.5" }}>ADVANCE</span>
          </div>
        ) : null}
        <div
          style={{
            height: "6vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            textAlign: "center",
            backgroundColor: "#7A92AC",
            padding: "1vw 0.5rem",
            borderTopLeftRadius: "5px",
            borderTopRightRadius: "5px",
            color: "#fff",
          }}
        >
          <span style={{ fontSize: "0.85rem", cursor: "pointer" }}>Estimate</span>
          <span style={{ fontSize: "0.7rem", display: "flex", alignItems: "center", justifyContent: "center" }}>
            {posConfig?.showEstimates !== "Y" && `Estimate No: ${estimateNo}`}
            {posConfig?.enableOrderLevelNarration === "Y" && (
              <img
                src={NotesAdd}
                onClick={() => {
                  setNotesPopup(true);
                  if (cart.description && cart.description.trim() !== "") {
                    setNotesValue(cart.description);
                  }
                  setIsInputFocused(true);
                }}
                style={{ height: "0.85rem", paddingLeft: "0.7rem", cursor: "pointer", paddingRight: "0.3rem" }}
              />
            )}
            {posConfig?.enableDeliveryDate === "Y" && isAdvanceOrderEnabled && (
              <Popover
                content={
                  <DatePicker
                    showTime={{ format: "hh:mm A" }}
                    format="DD-MM-YYYY hh:mm A"
                    onChange={handleDateSelect}
                    onOk={(date) => handleDateSelect(date, date ? date.format("DD-MM-YYYY hh:mm A") : "")}
                    disabledDate={(current) => current && current < dayjs().startOf("day")}
                    value={selectedDate}
                    style={{ width: 250 }}
                  />
                }
                trigger="click"
                open={calendarVisible}
                onOpenChange={(visible) => setCalendarVisible(visible)}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "6px",
                    padding: "3px 6px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    color: "white",
                    cursor: "pointer",
                    width: "fit-content",
                    marginLeft: "0.5rem",
                  }}
                >
                  <CalendarOutlined style={{ fontSize: "0.85rem", cursor: "pointer", paddingBottom: "0.1em" }} />
                  <span style={{ fontSize: "0.7rem" }}>{cart?.deliveryDate || "Delivery Date"}</span>
                </div>
              </Popover>
            )}
          </span>
        </div>

        {/* ——— CART TABLE ——— */}
        <Table
          className="sm-cart-table-pos"
          style={{
            width: "100%",
            overflowY: "auto",
            border: "none",
            borderRadius: "7px",
            padding: "0px 7px",
            height: "50.5vh",
            background: themeJSON.productTableBGColor || "#fff",
            fontSize: "0.78rem",
            overflowX: "hidden",
          }}
          pagination={false}
          dataSource={cartItems}
          sticky
          id="sm-cart-table"
          rowKey="lineId"
          rowClassName={(record) => (selectedProductInCart.lineId === record.lineId ? "tableRowSelectedBlue" : "tableRowNonSelectedWhite")}
          columns={cartColumns}
          {...(hasExpandableRows && {
            expandable: {
              expandedRowRender: (record) => (record.children && record.children.length > 0 ? <div></div> : null),
              rowExpandable: (record) => record.children && record.children.length > 0,
            },
          })}
          onRow={(record) => ({
            onClick: () => {
              qtyInputRef?.current?.focus();
              if (record.posPriceEdit === "Y") {
                setShowInputFields(true);
                setRealPrice(record.weight);
                setFirstInputValue(true);
              } else {
                setShowInputFields(false);
              }
              if (record.children && record.children.length > 0) {
                // See SMCartTable for context — children carry scaled weights;
                // restore per-unit before handing to the CustomMix modal so
                // submit doesn't re-multiply by groupQty. (Tab8 issues #8/#9)
                const groupQtyVal = Number(record.weight) || 1;
                const baseChildren = record.children.map((c) => {
                  const base = c.baseQty != null ? Number(c.baseQty) : groupQtyVal > 0 ? Number(c.weight) / groupQtyVal : Number(c.weight);
                  return { ...c, weight: base, rawWeight: String(base) };
                });
                setSelectedCustomMix(record);
                setCustomMixItems(baseChildren);
                setGroupName(record.name);
                setGroupQty(record.weight);
                setExistingGroupItems(true);
              }
              setIsInputFocused(false);
              setOverPayedAmount(0);
              setAmount(parseFloat((cart.total - cart.paid).toFixed(pricePrecision)));
              selectProductInCart(record);
              setQtyNumberFlag(0);
              setShowPaymentMethods(false);
              setSelectedProductInCart(record);
              setStockList([]);
            },
          })}
        />
      </div>

      {/* ——— CART TOTALS + HOLD/CANCEL ——— */}
      <CartTotalsPanel
        cart={cart}
        pricePrecision={pricePrecision}
        currenciesList={currenciesList}
        themeJSON={themeJSON}
        posConfig={posConfig}
        estimateNo={estimateNo}
        searchInputRef={searchInputRef}
        handleUpsertEstimate={handleUpsertEstimate}
        deleteCart={deleteCart}
        openDisplayParkedBillModal={openDisplayParkedBillModal}
        setEstimateNo={setEstimateNo}
      />
    </div>
  );
};

export default CartSection;
